import { overlay } from "overlay-kit";
import type { FC, ReactNode } from "react";

import { ConfirmationDialog } from "mds/components/ConfirmationDialog";

/**
 * When an AI action generates changes for a page, we want to show a modal
 * that shows the changes side by side with the original page.
 *
 * TODO: This is mostly unstyled right now, we could add some common styling for all the AI
 * change modals here.
 */
export const showChangeModal = (
  left: ReactNode,
  right: ReactNode,
  Wrapper?: FC<{ children: ReactNode }>,
) => {
  const contents = (
    <div className="flex max-h-[70vh] w-full flex-row gap-4 overflow-y-auto">
      <div className="flex w-full flex-col gap-4">
        <h4>Current:</h4>
        {left}
      </div>
      <div className="flex w-full flex-col gap-4">
        <h4>Suggested:</h4>
        {right}
      </div>
    </div>
  );
  const children = Wrapper ? <Wrapper>{contents}</Wrapper> : contents;
  return overlay.openAsync<boolean>(({ isOpen, close, unmount }) => (
    <ConfirmationDialog
      dialogContainerClassName="w-[calc(100vw-2rem)]"
      dialogPanelClassName="w-full"
      open={isOpen}
      onClose={(confirmed: boolean) => {
        close(confirmed);
        unmount();
      }}
      onConfirm={() => {}}
    >
      {children}
    </ConfirmationDialog>
  ));
};
